import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import {
  Card,
  Carousel,
  Flex,
  Form,
  Layout,
  Modal,
  Select,
  TableColumnsType,
  TableProps,
  Typography,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { KeyboardEvent, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import TableData from "../../../../../../components/table-data/TableData";
import { routesConfig } from "../../../../../../config/routes";
import {
  getHistoryReport,
  getSettingAttendanceReportByID,
} from "../../../../../../service/setting-attendance";
import { useStudyManagementStore } from "../../../../../../stores/stores";
import { DataType } from "../../../../../../types/listUsers";
import { formatDate } from "../../../../../../utils/converDate";
import { isEmpty } from "lodash";

type TableReportCheckInDetailProps = {
  title?: string;
  idDocument?: string;
  setReport: any;
  setParamStatus: any;
  setIdCourse: any;
  isViewHistory: boolean;
  setIsAction: (action: boolean) => void;
  idEditReport: number;
  setIdEditReport: (item: number) => void;
  role: any;
  setRole: (item: any) => void;
};

const TableReportCheckInDetail = ({
  title,
  idDocument,
  setReport,
  setParamStatus,
  setIdCourse,
  isViewHistory,
  setIsAction,
  idEditReport,
  setIdEditReport,
  role,
  setRole,
}: TableReportCheckInDetailProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const [accountReportCheckInDetail, setAccountReportCheckInDetail] = useState<
    DataType[]
  >([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [headValue, setHeadValue] = useState<any>([]);
  const [isAutoAttendance, setIsAutoAttendance] = useState<boolean>(false);

  const { setTitleAttendance } = useStudyManagementStore((state) => state);
  const [dataListReport, setDataListReport] = useState<any>([]);
  const [listImgAttendance, setListImgAttendance] = useState<any>({
    isOpen: false,
    listImg: [],
  });

  const pathName = location.pathname;

  const fetchData = async (idDocument: any) => {
    try {
      const response = await getSettingAttendanceReportByID(idDocument);
      const { data } = response.data;
      if (idEditReport) {
        const resHistory = await getHistoryReport(idEditReport);
        const { data } = resHistory.data;
        setAccountReportCheckInDetail(data?.mooc_attendance_history || []);
      } else {
        setAccountReportCheckInDetail(data?.data?.mooc_attendance || []);
      }
      setRole({
        is_edit: data?.is_edit,
        is_remove: data?.is_remove,
        is_view: data?.is_view,
        is_assign: data?.is_assign,
      });
      setTotalPage(data?.data?.total || 0);

      setParamStatus(
        data?.data?.mooc_attendance?.map((item: any) => ({
          id: item?.id,
          result: item?.result,
        }))
      );
      setDataListReport(
        data?.data?.mooc_attendance_report_history?.map((item: any) => ({
          id: item?.id,
          time: dayjs(item?.created_at).format("HH:mm:ss DD/MM/YYYY"),
        }))
      );
      setLoading(false);
      setReport({
        title: data?.data?.name || "",
        idReport: data?.data?.id,
      });
      setIdCourse(data?.data?.mooc_course.id);
      setTitleAttendance(data?.data.mooc_course.name);
      const vnTime = moment(data?.data?.created_at).tz("Asia/Ho_Chi_Minh");

      // Lấy giờ và phút từ thời gian đã chuyển đổi
      const hours = vnTime.hours();

      // Xác định khung giờ chẵn
      const getEvenHourRange = (hours: any) => {
        if (hours % 2 === 0) {
          return `${hours}:00 - ${hours + 2}:00`;
        } else {
          return `${hours - 1}:00 - ${hours + 1}:00`;
        }
      };

      setIsAutoAttendance(data?.data?.is_auto);
      setHeadValue([
        {
          label: t("Tên khoá học", "Tên khoá học"),
          value: data?.data.mooc_course.name,
        },
        {
          label: t("Chương", "Chương"),
          value:
            data?.data?.mooc_course_block?.mooc_course_unit
              ?.mooc_course_sequence.mooc_course_section.name,
        },
        {
          label: t("Bài giảng", "Bài giảng"),
          value:
            data?.data?.mooc_course_block?.mooc_course_unit
              ?.mooc_course_sequence.name,
        },
        {
          label: t("Học liệu", "Học liệu"),
          value: data?.data?.mooc_course_block?.title,
        },
        {
          label: t("Ngày học", "Ngày học"),
          value: data?.data?.created_at
            ? formatDate(data?.data?.created_at)
            : t("Không có ngày học", "Không có ngày học"),
        },
        {
          label: t("Thời gian học", "Thời gian học"),
          value: data?.data?.created_at
            ? getEvenHourRange(hours)
            : t("Không có thời gian học", "Không có thời gian học"),
        },
        {
          label: t("Sĩ số", "Sĩ số"),
          value: `${data?.data?.attendance}/${data.data.total}`,
        },
        {
          label: t("Tính chất điểm danh", "Tính chất điểm danh"),
          value: `${data?.data?.lesson ? t("Tiết học", "Tiết học") : ""}${
            data?.data?.discussion ? `, ${t("Thảo luận", "Thảo luận")}` : ""
          }${data?.data?.seminar ? `, ${t("Khảo sát", "Khảo sát")}` : ""}`,
        },
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(idDocument);
  }, [pageSize, pageNumber, idEditReport]);

  const handleChangeStatus = (value: any, id: number | string) => {
    setIsAction(true);
    setParamStatus((prevData: any[]) =>
      prevData.map((item: { id: string | number; result: any }) =>
        item.id === id ? { ...item, result: value } : item
      )
    );
  };

  const dataColumnsReportCheckInDetail: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      width: 10,
      render: (_: any, record, index) => {
        return <div>{index + 1}</div>;
      },
    },
    {
      title: t("Họ và tên sinh viên", "Họ và tên sinh viên"),
      dataIndex: "fullName",
      key: "fullName",
      width: 20,
      render: (_: any, record) => {
        return (
          <Typography.Text>
            {idEditReport
              ? record?.auth_user_mooc_attendance_history_student_idToauth_user
                  ?.auth_userprofile.name
              : record?.auth_user_mooc_attendance_student_idToauth_user
                  ?.first_name +
                " " +
                record?.auth_user_mooc_attendance_student_idToauth_user
                  ?.last_name}
          </Typography.Text>
        );
      },
    },
    {
      title: t("Ngày tháng năm sinh", "Ngày tháng năm sinh"),
      dataIndex: "date_of_birth",
      key: "date_of_birth",
      width: 20,
      render: (_: any, record) => {
        return (
          <Typography.Text>
            {idEditReport
              ? record?.auth_user_mooc_attendance_history_student_idToauth_user
                  ?.auth_userprofile?.date_of_birth &&
                formatDate(
                  record
                    ?.auth_user_mooc_attendance_history_student_idToauth_user
                    ?.auth_userprofile?.date_of_birth
                )
              : record?.auth_user_mooc_attendance_student_idToauth_user
                  ?.auth_userprofile?.date_of_birth &&
                formatDate(
                  record?.auth_user_mooc_attendance_student_idToauth_user
                    ?.auth_userprofile?.date_of_birth
                )}
          </Typography.Text>
        );
      },
    },
    {
      title: t("Số điện thoại", "Số điện thoại"),
      dataIndex: "phone_number",
      key: "phone_number",
      width: 20,
      render: (_: any, record) => {
        return (
          <Typography.Text>
            {idEditReport
              ? record?.auth_user_mooc_attendance_history_student_idToauth_user
                  ?.auth_userprofile?.phone_number
              : record?.auth_user_mooc_attendance_student_idToauth_user
                  ?.auth_userprofile?.phone_number}
          </Typography.Text>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 20,
      render: (_: any, record) => {
        return (
          <Typography.Text>
            {idEditReport
              ? record?.auth_user_mooc_attendance_history_student_idToauth_user
                  ?.email
              : record?.auth_user_mooc_attendance_student_idToauth_user?.email}
          </Typography.Text>
        );
      },
    },
    {
      title: t("Hình ảnh", "Hình ảnh"),
      dataIndex: "img",
      key: "img",
      width: 20,
      render: (_: any, record) => {
        const handleOpenImg = () => {
          setListImgAttendance({
            isOpen: true,
            listImg: record?.mooc_attendance_detail?.map((value: any) => ({
              file_path: value?.file_path,
              note: value?.note,
            })),
          });
        };
        return (
          <div onClick={handleOpenImg}>
            {!isEmpty(record?.mooc_attendance_detail) && (
              <img
                src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                alt=""
                className="w-[50px]"
              />
            )}
          </div>
        );
      },
    },
    {
      title: t("Điểm danh", "Điểm danh"),
      dataIndex: "courseType",
      key: "courseType",
      width: 20,
      render: (_: any, record) => {
        return (
          <div className="table-course-type">
            {pathName.includes(routesConfig.reportCheckInDetail) ||
            !role.is_edit ||
            isViewHistory ? (
              <div
                className={`${
                  record?.result ? "table-checkin-1" : "table-checkin-2"
                }`}
              >
                {record?.result ? t("Có mặt", "Có mặt") : t("Vắng mặt", "Vắng mặt")}
              </div>
            ) : (
              <Select
                defaultValue={record?.result ? t("Có mặt", "Có mặt") : t("Vắng mặt", "Vắng mặt")}
                style={{ width: 120 }}
                onChange={(value) => handleChangeStatus(value, record?.id)}
                options={[
                  { value: true, label: t("Có mặt", "Có mặt") },
                  { value: false, label: t("Vắng mặt", "Vắng mặt") },
                ]}
              />
            )}
          </div>
        );
      },
    },
  ];

  const defaultCheckedList = dataColumnsReportCheckInDetail.map(
    (item) => item.key as string
  );

  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const columnChecked = useMemo(() => {
    if (isViewHistory) {
      dataColumnsReportCheckInDetail.pop();
      dataColumnsReportCheckInDetail.push({
        title: t("Điểm danh", "Điểm danh"),
        dataIndex: "courseType",
        key: "courseType",
        width: 20,
        render: (_: any, record) => {
          return (
            <div className="table-course-type">
              <div
                className={`${
                  record?.result ? "table-checkin-1" : "table-checkin-2"
                }`}
              >
                {record?.result ? t("Có mặt", "Có mặt") : t("Vắng mặt", "Vắng mặt")}
              </div>
            </div>
          );
        },
      });
    }
    return dataColumnsReportCheckInDetail.map((item) => ({
      ...item,
    }));
  }, [checkedList, isViewHistory, idEditReport, role]);

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {};

  const handleSubmitSearch = () => {};

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {};

  return (
    <Layout className="page-header-group">
      <Form.Provider>
        <div className="px-6 pt-6 w-full">
          <Card>
            <Flex className="w-full 2xl:justify-between" wrap="wrap">
              {headValue?.map((dataReport: any, index: number) => (
                <div key={index}>
                  {isAutoAttendance &&
                  dataReport?.label === t("Thời gian học", "Thời gian học") ? null : (
                    <div
                      className={`${
                        index + 1 === headValue.length ? "" : "sm:border-r"
                      } px-4 w-full sm:w-1/2 md:w-1/4 mb-2 xl:mb-0 xl:w-fit`}
                    >
                      <p className="w-full">{dataReport.label}</p>
                      <p className="font-medium text-lg">{dataReport?.value}</p>
                    </div>
                  )}
                </div>
              ))}
            </Flex>
          </Card>
        </div>
        <Flex className="w-full">
          <div className={`${isViewHistory ? "w-4/5" : "w-full"}`}>
            <TableData
              dataTable={accountReportCheckInDetail}
              dataColumns={columnChecked}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              pageNumber={pageNumber}
              pageSize={pageSize}
              pagination={true}
              loadingTable={loading}
              scroll={{ x: 1500, y: 600 }}
              totalRecords={totalPage}
              handleTableChangeProps={handleTableChange}
            />
          </div>
          {isViewHistory && (
            <div className="w-1/5 my-[1.5rem] mr-[1.5rem] bg-white">
              <div className="h-full">
                <Typography.Title
                  level={5}
                  className="text-center border-b p-4 !mb-0"
                >{t("Phiên bản chỉnh sửa", "Phiên bản chỉnh sửa")}</Typography.Title>
                <div>
                  {dataListReport?.map((listReport: any, index: number) => (
                    <Flex
                      key={index}
                      className={`hover:bg-[#E6F7FF] p-4 ${
                        listReport?.id === idEditReport
                          ? "bg-[#E6F7FF] border-r-4 border-r-[#1890FF]"
                          : ""
                      }`}
                      onClick={() => setIdEditReport(listReport?.id)}
                    >
                      <Typography.Text className="pr-3">
                        {Number(index + 1)}
                      </Typography.Text>
                      <Typography.Text>
                        {t("Chỉnh sửa lúc", "Chỉnh sửa lúc")} {listReport?.time}
                      </Typography.Text>
                    </Flex>
                  ))}
                </div>
              </div>
            </div>
          )}
        </Flex>
      </Form.Provider>
      <Modal
        title={t("Các hình ảnh trong quá trình điểm danh", "Các hình ảnh trong quá trình điểm danh")}
        centered
        open={listImgAttendance.isOpen}
        onOk={() => setListImgAttendance({ isOpen: false, listImg: [] })}
        onCancel={() => setListImgAttendance({ isOpen: false, listImg: [] })}
        width={450}
        cancelText={t("Hủy", "Hủy")}
        okText={t("Xác nhận", "Xác nhận")}
      >
        <Carousel arrows infinite={false}>
          {!isEmpty(listImgAttendance?.listImg) && listImgAttendance?.listImg?.map((list: any, index: number) => (
            <div key={index}>
              <h3 className="text-center py-4 font-semibold">{list?.note}</h3>
              <img
                src={list?.file_path}
                alt=""
                className="w-[450px] object-cover"
              />
            </div>
          ))}
        </Carousel>
      </Modal>
    </Layout>
  );
};

export default TableReportCheckInDetail;
